// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"6973e766","377":"86712228","417":"fcb2bd11","467":"c251efd0","626":"e5e40771","870":"9a364e52"}[chunkId] + ".js";
};